import { invoke } from '@tauri-apps/api/core';
import type {
  ActivityBridge,
  ActivityRule,
  ActivitySegment,
  ActivitySegmentChanges,
  ActivitySettings,
  ActivityStatus,
  SaveActivityRuleInput,
} from './types';

export const tauriBridge: ActivityBridge = {
  getStatus() {
    return invoke<ActivityStatus>('get_activity_status');
  },
  getSettings() {
    return invoke<ActivitySettings>('get_activity_settings');
  },
  async updateSettings(changes) {
    const current = await this.getSettings();
    const settings: ActivitySettings = {
      ...current,
      ...changes,
      excludedApps: changes.excludedApps
        ? [...changes.excludedApps]
        : current.excludedApps,
    };
    return invoke<ActivitySettings>('update_activity_settings', { settings });
  },
  setEnabled(enabled) {
    return invoke<ActivityStatus>('set_activity_enabled', { enabled });
  },
  setPaused(paused) {
    return invoke<ActivityStatus>('set_activity_paused', { paused });
  },
  listSegments(input) {
    return invoke<ActivitySegment[]>('list_activity_segments', { input });
  },
  updateSegment(id: string, changes: ActivitySegmentChanges) {
    return invoke<ActivitySegment>('update_activity_segment', { id, changes });
  },
  deleteSegments(ids) {
    return invoke<void>('delete_activity_segments', { ids });
  },
  deleteAllActivityData() {
    return invoke<void>('delete_all_activity_data');
  },
  markSegmentImported(segmentId, taskId) {
    return invoke<void>('mark_activity_segment_imported', { segmentId, taskId });
  },
  listRules() {
    return invoke<ActivityRule[]>('list_activity_rules');
  },
  saveRule(rule: SaveActivityRuleInput) {
    return invoke<ActivityRule>('save_activity_rule', { rule });
  },
  deleteRule(id) {
    return invoke<void>('delete_activity_rule', { id });
  },
  setActiveUser(_userId) {
    // The native user partition is bound only by get/set/clear_auth_session,
    // alongside the secure credential operation. Do not expose an IPC command
    // that lets renderer code switch to an arbitrary local user partition.
    return this.getStatus();
  },
  exportDiagnostics() {
    return invoke<string>('export_activity_diagnostics');
  },
};
